import React from 'react';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { QueueTask } from 'components/queue';
import { Constants } from 'utilities/constants';

class QueueBin extends React.Component {
  constructor(props) {
    super(props);
    this.binRef = React.createRef();

    this.state = {
      scrollTop: 0,
    }
  }

  onScroll = () => {
    this.setState({ scrollTop: this.binRef.current?.scrollTop });
  }

  componentDidMount() {
    if (this.props.scroll && this.binRef.current) {
      this.binRef.current.scrollTop = this.props.scroll;
    }
  }

  componentWillUnmount() {
    this.props.handleScroll(this.state.scrollTop);
  }

  getTaskList = (bin) => {
    return bin.tasks.map((task) => (<QueueTask key={task.id} task={task} bin={bin} queueFilterInputLocalState={this.props.queueFilterInputLocalState} />));
  }

  getNoAssignedTasksCmp = () => {
    const { classes: { openedList, emptyMyTasksBinText }, module, bin, unloadedTaskCount } = this.props;
    
    const noSearchResultsMessage = bin?.hasNoSearchResults ? 'No search results' : null;
    const postAcqOnlyUnloadedMessage = !bin?.tasks.length && unloadedTaskCount > 0 ? `${unloadedTaskCount} ${unloadedTaskCount > 1 ? 'tasks require' : 'task requires'} data load` : null;
    const itemType = module === Constants.Module.POSTACQ ? 'tasks' : 'opps';
    
    return (
      <div className={openedList}>
        <Typography variant='body1' className={emptyMyTasksBinText}>
          {noSearchResultsMessage || postAcqOnlyUnloadedMessage || `No assigned ${itemType}`}
        </Typography>
      </div>
    );
  }

  render() {
    const { classes, bin } = this.props;

    return (
      bin?.id === 'allTasks' && bin?.tasks.length !== 0
        ? <List
            className={classes.openedList}
            dense
            id={bin.id}
            onScroll={this.onScroll}
            ref={this.binRef}
          >
            {this.getTaskList(bin)}
          </List>
        : this.getNoAssignedTasksCmp()
    )
  }
}

const styles = {
  openedList: {
    paddingTop: '0px',
    paddingBottom: '30px',          // Makes the queue lists not touch each other but smooths adding an item to the bottom of the list
    backgroundColor: '#f2f2f2',
    transition: 'background-color 0.2 ease',
    overflowY: 'auto',
    width: '100%'
  },
  emptyMyTasksBinText: {
    paddingTop: '5px',
    textAlign: 'center',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    color: '#A7A9AC',
    fontSize: '0.9rem',
    fontStyle: 'italic'
  }
}
export default withStyles(styles)(QueueBin);
